import { useState } from 'react';
import { DropPointType, DropPointTypes, ShippingMethod } from '~/lib/data-contract/salesforce';
import { useTranslation } from '~/shared/utils/translation';
import { MapMarker } from '../models';
import {
    filterByDropPointType,
    getForcedDropPointType,
    hasBothDropPointTypes,
    isPostnord,
} from '../utils/dropPointType';

export const usePostnordDropPoints = (
    mapMarkers: MapMarker[] | null,
    selectedCarrier?: ShippingMethod,
) => {
    const [dropPointType, setDropPointType] = useState<DropPointType>(DropPointTypes.both);
    const { translate } = useTranslation();
    const postnordMarkers = mapMarkers && isPostnord(mapMarkers) ? mapMarkers : null;
    const forcedType = postnordMarkers ? getForcedDropPointType(selectedCarrier) : undefined;
    // Only let the user filter when nothing is forced and there is something to choose between
    const showFilter = !!postnordMarkers && !forcedType && hasBothDropPointTypes(postnordMarkers);
    const activeType = forcedType ?? (showFilter ? dropPointType : DropPointTypes.both);

    return {
        visibleMarkers: mapMarkers && filterByDropPointType(mapMarkers, activeType),
        disclaimer: postnordMarkers ? translate('checkout.delivery.postnordDisclaimer') : '',
        showFilter,
        dropPointType,
        setDropPointType,
    };
};
